import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpService } from '../http.service';

@Component({
  selector: 'app-swinkpay-processing',
  templateUrl: './swinkpay-processing.component.html',
  styleUrls: ['./swinkpay-processing.component.scss'],
})
export class SwinkpayProcessingComponent implements OnInit {
  message: any;
  transactionId: any;
  bankName: any;
  amount: any = '0';
  razorpayid: any;
  deviceType: any;
  href: string = '';
  paymentType: any;
  payment_link_reference_id: any;
  payment_link_id: any;
  payment_status: any;
  razorpay_signature: any;
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private apiService: HttpService
  ) {}

  async ngOnInit() {
    this.href = this.router.url;
    console.log(this.href);
    // console.log(location.origin);
    // await this.insertLogs(this.href);
    this.transactionId = this.route.snapshot.queryParamMap.get('hdnRefNumber');
    //this.amount = this.route.snapshot.queryParamMap.get('amount');
    this.amount = 0;
    //const date = this.route.snapshot.queryParamMap.get('date');
    this.paymentType = this.route.snapshot.queryParamMap.get('paymentType');
    if (
      this.paymentType != null &&
      this.paymentType != undefined &&
      this.paymentType != ''
    ) {
      if (this.paymentType.toLowerCase() == 'razorpay') {
        this.razorpayid = this.route.snapshot.queryParamMap.get(
          'razorpay_payment_id'
        );
        this.payment_link_reference_id = this.route.snapshot.queryParamMap.get(
          'razorpay_payment_link_reference_id'
        );
        this.payment_link_id = this.route.snapshot.queryParamMap.get(
          'razorpay_payment_link_id'
        );
        this.payment_status = this.route.snapshot.queryParamMap.get(
          'razorpay_payment_link_status'
        );
        this.razorpay_signature =
          this.route.snapshot.queryParamMap.get('razorpay_signature');
      } else {
        this.razorpayid =
          this.route.snapshot.queryParamMap.get('transactionId');
      }
    } else {
      this.razorpayid = this.route.snapshot.queryParamMap.get('transactionId');
    }
    //const statusMessage = this.route.snapshot.queryParamMap.get('statusMessage');
    //const statusCode = this.route.snapshot.queryParamMap.get('statusCode');
    this.deviceType = this.route.snapshot.queryParamMap.get('deviceType');
    this.apiService.setLocalStorage('DeviceType', this.deviceType);
    this.apiService.setLocalStorage('Amount', this.amount);
    this.bankName =
      this.route.snapshot.queryParamMap.get('bankName') == null
        ? ''
        : this.route.snapshot.queryParamMap.get('bankName');
    this.message = 'Processing payment';

    await this.postPaymentDetails();
  }
  async postPaymentDetails() {
    let model: any;

    if (this.paymentType.toLowerCase() == 'razorpay') {
      model = {
        bankName: this.bankName,
        order_id: this.transactionId,
        razorpay_payment_id: this.razorpayid,
        razorpay_amount: this.amount,
        paymentType: this.paymentType.toLowerCase(),
        payment_link_reference_id: this.payment_link_reference_id,
        payment_link_id: this.payment_link_id,
        payment_status: this.payment_status,
        razorpay_signature: this.razorpay_signature,
      };
    } else {
      model = {
        bankName: this.bankName,
        order_id: this.transactionId,
        razorpay_payment_id: this.razorpayid,
        razorpay_amount: this.amount,
        paymentType: this.paymentType.toLowerCase(),
      };
    }

    let result = await this.apiService.postRazorPaymentDetails(model);

    if (result) {
      this.apiService.setLocalStorage('Message', result.message);
      this.apiService.setLocalStorage('ChegUrl', result.chegUrl);

      // if (result.status == 'COMPLETE') {
      //   this.router.navigate(['/success']);

      // } else if (result.status == 'Payment failed') {
      //   this.apiService.setLocalStorage('Message', result.message);
      //   console.log("2", result);
      //   this.router.navigate(['/payment-failure']);
      // } else if (result.status == 'payment progress') {
      //   this.message = result.message;
      //   this.apiService.setLocalStorage('Message', result.message);
      //   this.router.navigate(['/payment-pending']);
      //   // alert(result.message);//closable popup
      // } else if (result.status == 'failed') {
      //   this.apiService.setLocalStorage('Message', result.message);
      //   this.router.navigate(['/failure']);
      // } else if (result.status == 'invalid') {
      //   this.apiService.setLocalStorage('Message', result.message);
      //   this.router.navigate(['/failure']);
      // } else if (result.status == 'Invalid Amount') {
      //   this.apiService.setLocalStorage('Message', result.message);
      //   this.router.navigate(['/failure']);
      // } else if (result.status == 'PROCESSING') {
      //   this.apiService.setLocalStorage('Message', result.message);
      //   this.router.navigate(['/success']);
      // }

      let status = result.status.toLowerCase();

      if (status == 'complete') {
        this.router.navigate(['/success']);
      } else if (status == 'payment failed') {
        this.apiService.setLocalStorage('Message', result.message);
        console.log('2', result);
        this.router.navigate(['/payment-failure']);
      } else if (status == 'payment progress') {
        this.message = result.message;
        this.apiService.setLocalStorage('Message', result.message);
        this.router.navigate(['/payment-pending']);
        // alert(result.message);//closable popup
      } else if (status == 'failed') {
        this.apiService.setLocalStorage('Message', result.message);
        this.router.navigate(['/failure']);
      } else if (status == 'invalid') {
        this.apiService.setLocalStorage('Message', result.message);
        this.router.navigate(['/failure']);
      } else if (status == 'invalid amount') {
        this.apiService.setLocalStorage('Message', result.message);
        this.router.navigate(['/failure']);
      } else if (status == 'processing') {
        this.apiService.setLocalStorage('Message', result.message);
        this.router.navigate(['/success']);
      }
    }
  }
  async insertLogs(url: any) {
    let data = {
      moduleName: 'Swinkpay url fired',
      url: url,
    };
    let result = this.apiService.insertLogs(data);
  }
}
